export enum ConfirmPopupAction {
    Close = 'close',
    Back = 'back',
}
